import { FullContainer } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { GPT_DETAIL_PAGE } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { pageState } from '../../storage/app';
import MapWrapper from '../map/MapWrapper';

function PageLayout() {
  const { css } = useStyles();
  const page = useRecoilValue(pageState);
  const hasMap = page === GPT_DETAIL_PAGE.id;

  return (
    <FullContainer
      flexible
      classNames={css({
        position: 'relative',
        overflow: 'hidden',
      })}
    >
      {hasMap && <MapWrapper />}
      <Outlet />
    </FullContainer>
  );
}

export default memo(PageLayout);
